import { Injectable } from '@angular/core';
import { SSOService } from './sso/sso.service';
import { HttpRequest } from '@angular/common/http';
import { IAuthService } from '../authentication/iauth.service'

@Injectable({providedIn: 'root'})
export class AuthService {
    cachedRequests: Array<HttpRequest<any>> = [];

    constructor(private ssoService: SSOService,
    ) { }

    public shouldReload: boolean = false;
    public providerName: string = null;
    public redirectUri: string = null;

    public async authenticate() {
        let res = await this.ServiceFactory(this.providerName).authenticate();
    }

    private ServiceFactory(type: string): IAuthService {
        switch (type) {
            default:
                return this.ssoService;
        }
    }
}
